/// <reference types="vite/client" />
import { createClient, SupabaseClient } from '@supabase/supabase-js';

let supabaseInstance: SupabaseClient | null = null;
let supabaseConfigured = false;

// Access env vars directly so Vite can statically replace them at build time
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

export function isSupabaseConfigured(): boolean {
  if (supabaseConfigured) return true;

  supabaseConfigured = !!(SUPABASE_URL && SUPABASE_ANON_KEY);
  return supabaseConfigured;
}

export function getSupabaseClient(): SupabaseClient {
  if (supabaseInstance) {
    return supabaseInstance;
  }

  if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
    console.warn('Supabase not configured - profile features disabled');
    // Return a mock client that won't make real requests
    // This allows the app to function without Supabase for auth-only flows
    throw new Error('Supabase not configured');
  }

  supabaseInstance = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  });

  return supabaseInstance;
}

export const supabase = {
  get client() {
    return getSupabaseClient();
  },
};
